var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":require("@/assets/sigefHome.png")}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }